import * as React from 'react'
import MaskedInput from 'react-text-mask'

import { CalendarIcon } from '../../../images/icons/Calendar/Calendar'

import './styles.css'

export class DateInput extends React.Component<any, any> {
    getFormattedDate = (date: any) => {

        var newDate = new Date(date)
        let _datee = `${String(newDate.getDate()).length < 2 ? 0 : ''}${newDate.getDate()}`

        return `${_datee}-${newDate.getMonth() < 9 ? '0' : ''}${newDate.getMonth() + 1}-${newDate.getFullYear()}`
    }

    render() {
        const {
            placeholder,
            guide,
            value,
            onChange,
            showIcon = true,
            maskTypeChange = false,
            placeholderIsDate = false,
        } = this.props

        return (
            <div className="date-input-wrapper">
                <div>
                    <MaskedInput
                        mask={maskTypeChange ? [/[0-3]/, /\d/, '-', /[0-1]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] :
                            [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                        className="date-input-wrapper__input"
                        placeholder={placeholderIsDate ? this.getFormattedDate(placeholder) : placeholder}
                        guide={guide}
                        onChange={(e) => onChange(e.target.value)}
                        value={value}
                    />
                    {showIcon &&
                        <div className="date-input-wrapper__icon">
                            <CalendarIcon />
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default DateInput



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/DateInput/index.tsx